import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "flex-center loginPage"
};
const _hoisted_2 = {
  class: "left"
};
const _hoisted_3 = {
  class: "login-box"
};
const _hoisted_4 = {
  class: "input-form"
};
const _hoisted_5 = {
  class: "flex w100"
};
const _hoisted_6 = {
  class: "flex w100"
};
import { ref } from "vue";
import SendMsg from "@/components/SendMsg.vue";
import AccountTop from "@/components/AccountTop.vue";
import { useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import { httpPost } from "@/utils/http";
import AccountBg from "@/components/AccountBg.vue";
import { showMessageInfo } from "@/utils/dialog";
import * as authUtil from '@/utils/auth';
import * as LoginApi from '@/api/login';
const scene = 23;
export default /*@__PURE__*/_defineComponent({
  __name: 'Resetpassword',
  setup(__props) {
    const router = useRouter();
    const userType = router.currentRoute.value.query["type"];
    const form = ref({
      tenantCode: "",
      mobile: "",
      email: "",
      type: "mobile",
      code: "",
      password: "",
      repass: ""
    });
    // 获取租户 ID
    const loadTenantId = async () => {
      if (userType === 'enterprise') {
        const res = await LoginApi.getTenantIdByCode(form.value.tenantCode);
        if (!res) {
          showMessageInfo("租户编码不存在！");
          return false;
        }
        authUtil.setTenantId(res);
      } else {
        authUtil.setTenantId(1);
      }
      return true;
    };
    const save = async () => {
      if (userType === 'enterprise' && !(await loadTenantId())) {
        return;
      }
      if (form.value.code === "") {
        return ElMessage.error("请输入验证码");
      }
      if (form.value.password.length < 8) {
        return ElMessage.error("密码长度必须大于8位");
      }
      if (form.value.repass !== form.value.password) {
        return ElMessage.error("两次输入密码不一致");
      }
      httpPost("/system/auth/reset-password", form.value).then(() => {
        ElMessage.success({
          message: "重置密码成功",
          duration: 1000
        });
      }).catch(e => {
        ElMessage.error("重置密码失败：" + e.message);
      });
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createElementBlock(_Fragment, null, [_cache[15] || (_cache[15] = _createElementVNode("div", {
        class: "reset-pass"
      }, null, -1)), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(AccountTop, {
        title: "重置密码"
      }), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_form, {
        model: form.value
      }, {
        default: _withCtx(() => [_unref(userType) === 'enterprise' ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 0,
          label: "租户编码",
          "label-position": "top",
          prop: "tenantCode"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.value.tenantCode,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.tenantCode = $event),
            size: "large",
            placeholder: "请输入租户编码"
          }, null, 8, ["modelValue"])]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_tabs, {
          modelValue: form.value.type,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.value.type = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
            label: "手机号验证",
            name: "mobile"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [_cache[8] || (_cache[8] = _createElementVNode("div", {
                class: "form-title"
              }, "手机号码", -1)), _createVNode(_component_el_input, {
                modelValue: form.value.mobile,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.mobile = $event),
                size: "large",
                placeholder: "请输入手机号"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [_cache[9] || (_cache[9] = _createElementVNode("div", {
                class: "form-title"
              }, "验证码", -1)), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_input, {
                placeholder: "请输入验证码",
                size: "large",
                maxlength: "10",
                class: "code-input",
                modelValue: form.value.code,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.code = $event),
                autocomplete: `nope-${Date.now()}`,
                name: `vcode_${Math.random().toString(36).substr(2, 9)}`,
                id: `vcode_${Math.random().toString(36).substr(2, 9)}`
              }, null, 8, ["modelValue", "autocomplete", "name", "id"]), _createVNode(SendMsg, {
                size: "large",
                receiver: form.value.mobile,
                scene: scene,
                type: "mobile"
              }, null, 8, ["receiver"])])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_tab_pane, {
            label: "邮箱验证",
            name: "email",
            disabled: true
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [_cache[10] || (_cache[10] = _createElementVNode("div", {
                class: "form-title"
              }, "邮箱", -1)), _createVNode(_component_el_input, {
                modelValue: form.value.email,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.email = $event),
                placeholder: "请输入邮箱",
                size: "large"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [_cache[11] || (_cache[11] = _createElementVNode("div", {
                class: "form-title"
              }, "验证码", -1)), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_input, {
                modelValue: form.value.code,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.code = $event),
                maxlength: "6",
                size: "large",
                placeholder: "请输入验证码",
                class: "code-input"
              }, null, 8, ["modelValue"]), _createVNode(SendMsg, {
                size: "large",
                receiver: form.value.email,
                type: "email"
              }, null, 8, ["receiver"])])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_cache[12] || (_cache[12] = _createElementVNode("div", {
            class: "form-title"
          }, "新密码", -1)), _createVNode(_component_el_input, {
            modelValue: form.value.password,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.value.password = $event),
            type: "password",
            placeholder: "请输入新密码(8-16位)",
            size: "large"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_cache[13] || (_cache[13] = _createElementVNode("div", {
            class: "form-title"
          }, "重复密码", -1)), _createVNode(_component_el_input, {
            modelValue: form.value.repass,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => form.value.repass = $event),
            type: "password",
            placeholder: "请再次输入密码(8-16位)",
            size: "large"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            class: "login-btn",
            size: "large",
            type: "primary",
            onClick: save
          }, {
            default: _withCtx(() => _cache[14] || (_cache[14] = [_createTextVNode(" 重置密码 ")])),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])])])]), _createVNode(AccountBg)])], 64);
    };
  }
});